import { BaseModel } from '@/api/base-model'
import { TriggeredActionAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'
import { User } from '@/api/model/user'
import { ActionAssignToType, ActionType, DelayUnit, ReferralOrigin, TriggerType} from '@/api/types'
import { Branch } from '@/api/model/branch'
import { Source } from '@/api/model/source'
import { PipelinePhase } from '@/api/model/pipeline-phase'

export  class TriggeredAction extends BaseModel<TriggeredAction> {
    protected  collectionName = TriggeredActionAPI.collectionName

    constructor(
        public company: Company,
        public id: string,
        public triggerType: TriggerType,
        public changedField: string|null,
        public changedFieldValue: string|null,
        public emptyField: string|null,
        public delayQuantity: number,
        public delayUnit: DelayUnit,
        public referralPipeline: Pipeline|null,
        public referralType: string,
        public referralOrigin: ReferralOrigin,
        public actionType: ActionType,
        public actionAppointmentType: string|null,
        public actionAssignTo: User[],
        public actionAssignToType: ActionAssignToType,
        public actionComment: string,
        public newReferralPipeline: Pipeline|null,
        public phase: PipelinePhase|null,
        public assignedToBranch: Branch|null,
        public assignedTo: User|null,
        public createdAt: Date,
        public updatedAt: Date,
    ) {
        super(id)
    }

    static fromData(data: any): TriggeredAction {
        if (data == null || typeof data === 'string' || data instanceof TriggeredAction) {
            return data
        }

        return new TriggeredAction(
            data.company,
            data.id,
            data.triggerType,
            data.changedField,
            data.changedFieldValue,
            data.emptyField,
            data.delayQuantity,
            data.delayUnit,
            data.referralPipeline ? Pipeline.fromData(data.referralPipeline) : null,
            data.referralType,
            data.referralOrigin,
            data.actionType,
            data.actionAppointmentType,
            Object.values(data.actionAssignTo || {}).map(entry => User.fromData(entry)),
            data.actionAssignToType,
            data.actionComment,
            data.newReferralPipeline ? Pipeline.fromData(data.newReferralPipeline) : null,
            data.phase ? PipelinePhase.fromData(data.phase) : null,
            data.assignedToBranch ? Branch.fromData(data.assignedToBranch) : null,
            data.assignedTo ? User.fromData(data.assignedTo) : null,
            data.createdAt,
            data.updatedAt,
        )
    }
}
